import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DialogButton } from '../../models/enums/dialogbutton.enum';
import { LayoutService } from '../../services/layout.service';
import { WorkerInfoService } from '../../services/worker.info.service';
import { BaseDialog } from '../dialogs/basedialog/base.dialog';
import moment from 'moment';

@Component({
    selector: 'worker-info-control',
    templateUrl: './worker.info.control.html',
    styleUrls: ['./worker.info.control.css']
})
export class WorkerInfoControl implements OnInit {
    Workers = [];
    SelectedWorker: any;
    WorkerLog: string;

    static ShowDialog() {
        BaseDialog.ShowDialog({
            ContentType: WorkerInfoControl,
            Buttons: DialogButton.Ok,
            FullScreen: true,
            AutoFocus: false,
            Title: '@@WorkerInfo'
        });
    }

    constructor(private cdRef: ChangeDetectorRef, private service: WorkerInfoService) {
    }

    ngOnInit(): void {
        this.service.ReadWorker().subscribe(x => {
            if (x) {
                x.forEach((wi: any) => {
                    wi.TimeInfo = moment(wi.StartDate).format('lll') + ' - ' + moment(wi.EndDate).format('lll');
                });
                this.Workers = x;
                this.cdRef.detectChanges();
            }
        });
    }

    onItemClick(data: any) {
        if (data != this.SelectedWorker) {
            LayoutService.Loading.next(true);
            this.SelectedWorker = data;
            this.service.GetWorkerLog(data.ID).subscribe(x => {
                LayoutService.Loading.next(false);
                this.WorkerLog = x;
                this.cdRef.detectChanges();
            });
        }
    }
}